import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'

export default function Main() {
  const [name, setName] = useState('')
  const [alt, setAlt] = useState('')
  const [title, setTitle] = useState('')
  const [id, setId] = useState('')
  const [type, setType] = useState('image_hotel')
  const [img, setImage] = useState('https://tawaftravel.co.uk/images/hotel/')
  const [all, setAll] = useState([])

  useEffect(() => {
    get();
  }, []);

  const getAllImages = async (id) => {
    const data = new FormData();
    data.append('id', id);

    axios({
      method: 'post',
      url: '/api/hotel_img/view.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        setAll(s.data)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const delete_now = async (id) => {
    const data = new FormData();
    data.append('id', id);

    axios({
      method: 'post',
      url: '/api/hotel_img/delete.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        getAllImages(id)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const get = () => {
    const queryParams = new URLSearchParams(window.location.search)
    const id = queryParams.get("id")
    const name = queryParams.get("hotel_name")
    setId(id)
    setName(name)
    getAllImages(id)
  };

  const getDb = async () => {
    const data = new FormData();
    data.append('alt', alt);
    data.append('title', title);
    data.append('get_id', id);
    data.append('type', type);
    data.append('img', img);

    axios({
      method: 'post',
      url: '/api/hotel_img/add.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        console.log("run")
        if (s.data[0].msg == "already") {
          alert("already SEO here")
        } else if (s.data[0].msg == "fail") {
          alert("Fail here")
        } else {
          alert("Saved here")
        }
        getAllImages(id)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            <div className="page-content">
{/* Header for Add Image Form */}
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card modern-card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div className="avatar avatar-sm me-3 bg-white text-dark rounded-circle d-flex align-items-center justify-content-center">
                          <i className="link-icon" data-feather="upload" style={{ width: '18px', height: '18px' }}></i>
                        </div>
                        <div>
                          <h4 className="mb-1">Add New Image</h4>
                          <span className="opacity-75">Upload new images for hotel gallery</span>
                        </div>
                        <span className="badge bg-light text-dark ms-auto py-2 px-3">
                          <i className="link-icon me-1" data-feather="plus-circle" style={{ width: '14px', height: '14px' }}></i>
                          Add New
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-8 mb-3">
                          <label htmlFor="hotelName" className="form-label fw-bold">
                            <i className="fas fa-hotel me-2"></i>
                            Hotel Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="hotelName"
                            disabled
                            autoComplete="off"
                            placeholder=""
                            value={name} onChange={(v) => { setName(v.target.value) }}
                          />
                        </div>
                        <div className="col-lg-4 mb-3">
                          <label htmlFor="type" className="form-label fw-bold">
                            <i className="fas fa-tag me-2"></i>
                            Type
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="type"
                            autoComplete="off"
                            placeholder=""
                            disabled
                            value={type} onChange={(v) => { setType(v.target.value) }}
                          />
                        </div>
                        <div className="col-lg-12 mb-3">
                          <label htmlFor="imageUrl" className="form-label fw-bold">
                            <i className="fas fa-link me-2"></i>
                            Image URL / Path
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="imageUrl"
                            autoComplete="off"
                            placeholder="https://tawaftravel.co.uk/images/hotel/"
                            value={img} onChange={(v) => { setImage(v.target.value) }}
                          />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label htmlFor="altText" className="form-label fw-bold">
                            <i className="fas fa-font me-2"></i>
                            Alt Text
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="altText"
                            autoComplete="off"
                            placeholder=""
                            value={alt} onChange={(v) => { setAlt(v.target.value) }}
                          />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label htmlFor="imageTitle" className="form-label fw-bold">
                            <i className="fas fa-heading me-2"></i>
                            Image Title
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="imageTitle"
                            autoComplete="off"
                            placeholder=""
                            value={title} onChange={(v) => { setTitle(v.target.value) }}
                          />
                        </div>
                      <div className="col-lg-12 d-flex justify-content-end mt-4">
  <button
    className="btn btn-primary px-4 d-flex align-items-center"
    onClick={() => {
      getDb();
    }}
  >
    <i className="link-icon me-2" data-feather="plus"></i>
    Add Hotel Image
  </button>
</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Header for Images Table */}
              <div className="row mb-4">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card modern-card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div className="avatar avatar-sm me-3 bg-white text-dark rounded-circle d-flex align-items-center justify-content-center">
                          <i className="link-icon" data-feather="image" style={{ width: '18px', height: '18px' }}></i>
                        </div>
                        <div>
                          <h4 className="mb-1">Hotel Images Gallery</h4>
                          <span className="opacity-75">Managing images for: {name || 'Loading...'}</span>
                        </div>
                        <span className="badge bg-light text-dark ms-auto py-2 px-3">
                          <i className="link-icon me-1" data-feather="layers" style={{ width: '14px', height: '14px' }}></i>
                          {all.length} Images
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table id="dataTableExample" className="table">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Image</th>
                              <th>Alt Text</th>
                              <th>Title</th>
                              <th>Description</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              all.map((v) => (
                                <tr key={v.id}>
                                  <td>{v.id}</td>
                                  <td>
                                    <div className="text-truncate" style={{ maxWidth: '200px' }}>
                                      {v.img}
                                    </div>
                                  </td>
                                  <td>{v.alt}</td>
                                  <td>{v.t}</td>
                                  <td>{v.des}</td>
                                  <td>
                                    <button
                                      onClick={() => {
                                        if (window.confirm('Are you sure you want to delete this image?')) {
                                          delete_now(v.id)
                                        }
                                      }}
                                      className="btn btn-danger btn-sm d-flex align-items-center px-2 py-1"
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                                        <polyline points="3 6 5 6 21 6"></polyline>
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                      </svg>
                                      Delete
                                    </button>
                                  </td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}